import { render, staticRenderFns } from "./RetoureShelf.vue?vue&type=template&id=d5fc12c8&scoped=true"
import script from "./RetoureShelf.vue?vue&type=script&lang=js"
export * from "./RetoureShelf.vue?vue&type=script&lang=js"
import style0 from "./RetoureShelf.vue?vue&type=style&index=0&id=d5fc12c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fc12c8",
  null
  
)

export default component.exports